export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: '.swiper-button-next.banners',
      prevEl: '.swiper-button-prev.banners',
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperLocations = new Swiper('.swiper-locations', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.locations',
      prevEl: '.swiper-button-prev.locations',
    },
    pagination: {
      el: '.swiper-pagination.locations',
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
  });

  const swiperBlogInternalRelated = new Swiper('.blog-internal-related-slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    watchOverflow: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.blog-internal',
      prevEl: '.swiper-button-prev.blog-internal',
    },
    pagination: {
      el: '.swiper-pagination.blog-internal',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  const swiperUsedModelInternalStamp = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 2,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    autoHeight: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 6,
      },
      1600: {
        slidesPerView: 8,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next.stamp',
      prevEl: '.swiper-button-prev.stamp',
    },
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });



  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    pagination: {
      el: '.swiper-pagination.used',
      clickable: true
    },
  });


  const swiperUsedModelInternalPremiumStamp = new Swiper('.used-model-internal-premium-stamps-slider', {
    clickable: true,
    slidesPerView: 2,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    autoHeight: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 8,
        spaceBetween: 30
      }
    },
    navigation: {
      nextEl: '.swiper-button-next.stamp',
      prevEl: '.swiper-button-prev.stamp',
    },
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });



  const usedModelInternalPremiumSwiper = new Swiper('.used-model-internal-premium-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    pagination: {
      el: '.swiper-pagination.used',
      clickable: true
    },
  });

  const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });

  const highlightsCategoriesSwiper = new Swiper('.categories-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.categories-next',
      prevEl: '.swiper-button-prev.categories-prev',
    },
    pagination: {
      el: '.swiper-pagination.categories',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    }
  });

  const destaquesSwiper = new Swiper('.destaques-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.destaques-next',
      prevEl: '.swiper-button-prev.destaques-prev',
    },
    pagination: {
      el: '.swiper-pagination.destaques',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    }
  });

  const brandsSwiper = new Swiper('.brands-swiper', {
    slidesPerView: 5,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.brands-next',
      prevEl: '.swiper-button-prev.brands-prev',
    },
    pagination: {
      el: '.swiper-pagination.brands',
      clickable: true
    },
  });

  const tourVirtualSwiper = new Swiper('.tour-virtual-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.tour-virtual-next',
      prevEl: '.swiper-button-prev.tour-virtual-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  });

  const ourStoresSwiper = new Swiper('.our-stores-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.our-stores-pagination',
      clickable: true
    },
  });

}


